import * as React from 'react';
import { IRestCardTagActivity } from '../../../../../../../types/rest/activity/IRestCardTagActivity';
import { IActivityProps } from '../../../../boardDetails/activity/TabActivity/types';
import { TabActivityContext } from '../../../../boardDetails/activity/TabActivity/components/TabActivity/constants';
import { TActivity } from '../../../../../../../store/activities/types';
import {
    ActivityItemBody
} from '../../../../boardDetails/activity/TabActivity/components/ActivityItemBody/ActivityItemBody';
import { ActivityHeader } from '../../../../boardDetails/activity/TabActivity/components/ActivityHeader/ActivityHeader';
import { ActivityTags } from '../ActivityTags/ActivityTags';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardActivityTags`) : null;

export function CardActivityTags({
    activity,
    asidePanelWidth
}: IActivityProps<IRestCardTagActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const { onOpenCard } = React.useContext(TabActivityContext);
    const { label, card } = activity as TActivity;
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} activity={activity} />}
            activity={activity}
            onClick={() => onOpenCard(card.id, activity.id, 'tags')}
        >
            <ActivityTags tags={activity.tags} asidePanelWidth={asidePanelWidth} />
        </ActivityItemBody>
    );
};
